<section *ngIf="badges.length"
         class="open-badges">

    <h2 class="open-badges__title">{{ "my_profile.my_open_badges" | translate }}</h2>

    <ul class="open-badges__list">
        <li *ngFor="let badge of badges"
            class="open-badges__card"
            [class.open-badges__card--locked]="!badge?.get('unLocked')"
            [style.background-image]="'url(' + badge?.get('image') + ')'"
            [matTooltip]="badge?.get('name')"
            (click)="onClick(badge)">
            <mat-icon *ngIf="!badge?.get('unLocked')"
                      class="open-badges__locked-card-icon"
                      svgIcon="lock-rounded-fill">
            </mat-icon>
        </li>
    </ul>

</section>